var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 12,
    height: 9.433,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-98 -50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 16,
    height: 16,
    transform: "translate(98 50)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(101 46.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    transform: "translate(-1 7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M10.118,3.9l-1.5.924-.08-.414a4.981,4.981,0,0,1-.064-1.445l.066-.648h2.416a1.138,1.138,0,0,0,1.118-1.156A1.138,1.138,0,0,0,10.957,0H5.211A1.138,1.138,0,0,0,4.093,1.156H.134v3.87A4.336,4.336,0,0,0,4.4,9.433,4.155,4.155,0,0,0,7.022,8.5l4.241-2.614A1.178,1.178,0,0,0,11.651,4.3a1.1,1.1,0,0,0-1.533-.4",
    transform: "translate(-0.075 0)",
    fill: "#f9c041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M6.4,0H1.118A1.138,1.138,0,0,0,0,1.156,1.138,1.138,0,0,0,1.118,2.312h.951a.014.014,0,0,1,.014.015v1.81A1.138,1.138,0,0,0,3.2,5.293a1.125,1.125,0,0,0,1.08-.863,1.108,1.108,0,0,0,2.166-.019,1.126,1.126,0,0,0,1.085.881A1.138,1.138,0,0,0,8.651,4.137V2.327A2.292,2.292,0,0,0,6.4,0",
    transform: "translate(0 0)",
    fill: "#fcd541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M4.356,8.005a1.314,1.314,0,0,1-1.29-1.334V5.025h-.62a.178.178,0,0,1,0-.356H3.18a.234.234,0,0,1,.229.237V6.671a.964.964,0,0,0,.946.978.178.178,0,0,1,0,.356",
    transform: "translate(-1.268 -2.534)",
    fill: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M8.145,1.572a.175.175,0,0,1-.172-.178A.964.964,0,0,0,7.027.416.175.175,0,0,1,6.855.238.175.175,0,0,1,7.027.06a1.314,1.314,0,0,1,1.29,1.334.175.175,0,0,1-.172.178",
    transform: "translate(-3.824 -0.032)",
    fill: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M13.03,1.572a.175.175,0,0,1-.172-.178.964.964,0,0,0-.946-.978A.175.175,0,0,1,11.74.238.175.175,0,0,1,11.912.06,1.314,1.314,0,0,1,13.2,1.394a.175.175,0,0,1-.172.178",
    transform: "translate(-6.549 -0.032)",
    fill: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M10.645,12.53a.17.17,0,0,1-.128-.059.183.183,0,0,1,.013-.251,7.159,7.159,0,0,1,2.3-1.258.172.172,0,0,1,.215.117.179.179,0,0,1-.113.223,6.947,6.947,0,0,0-2.175,1.183.168.168,0,0,1-.115.046",
    transform: "translate(-5.842 -5.946)",
    fill: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M6.849,8.931a.13.13,0,0,1,.126.155.7.7,0,0,1-1.376,0,.13.13,0,0,1,.126-.155Z",
    transform: "translate(-3.122 -4.848)",
    fill: "#ffe183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M11.973,8.931a.13.13,0,0,1,.126.155.7.7,0,0,1-1.376,0,.13.13,0,0,1,.126-.155Z",
    transform: "translate(-5.98 -4.848)",
    fill: "#ffe183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M16.909,8.931a.13.13,0,0,1,.126.155.7.7,0,0,1-1.376,0,.13.13,0,0,1,.126-.155Z",
    transform: "translate(-8.734 -4.848)",
    fill: "#ffe183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M10.655,7.65a.964.964,0,0,1-.946-.978V4.861a.19.19,0,0,0-.186-.192.171.171,0,0,0-.158.108V6.671a1.314,1.314,0,0,0,1.29,1.334.178.178,0,0,0,0-.356",
    transform: "translate(-5.224 -2.534)",
    fill: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M15.591,7.65a.964.964,0,0,1-.946-.978V4.861a.19.19,0,0,0-.186-.192.171.171,0,0,0-.158.108V6.671a1.314,1.314,0,0,0,1.29,1.334.178.178,0,0,0,0-.356",
    transform: "translate(-7.978 -2.534)",
    fill: "#ffaf2c"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.8f8878fc.svg";
export { ForwardRef as ReactComponent };